import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  metaTagsDetails: {},
  isLoading: false,
  error: "",
  hasData: false
};
const metaTagsSlice = createSlice({
  name: "metaTags",
  initialState,
  reducers: {
    metaTagsDataRequest: state => {
      state.isLoading = true;
    },
    getMetaTagsDataSuccess: (state, action) => {
      const data = action.payload;
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.metaTagsDetails = data;
    },
    getMetaTagsDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  metaTagsDataRequest,
  getMetaTagsDataSuccess,
  getMetaTagsDataFailure
} = metaTagsSlice.actions;
export default metaTagsSlice.reducer;